import { render, staticRenderFns } from "./RestrictedArea.vue?vue&type=template&id=480085de"
import script from "./RestrictedArea.vue?vue&type=script&lang=js"
export * from "./RestrictedArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports